// Get survey codes from:
// https://ampol.atlassian.net/wiki/spaces/SD/pages/3964010587/Zonka+Surveys
export default {
  MAIN_PAGE_SURVEY: 'g48vAE',
  MAIN_PAGE_SURVEY_2: 'R04dLo',
  UPDATING_ACCOUNT_ADDRESSES: '4PUg1b',
  ADDING_CARD_FAVOURITES: 'Uo6D1u',
  LINKING_EVERYDAY_REWARDS_XERO_MYOB: 'aI9L8a',
  RUNNING_DIRECT_DEBIT_PAYMENT: 'k1GZh8',
  ORDERING_NEW_CARD: 'xsCG39',
  SUBMITTING_EDIT_CARD_REQUEST: 'jSkV80',
  SETTING_OR_RESETTING_PIN: 'tH6H0p',
  UPDATING_CARD_STATUS: 'y37FZj',
  CREATE_REPORT: 'YOf3i7',
  DOWNLOADING_INVOICE_STATEMENTS: 'j6H4Bf',
} as const;
